import React from 'react'
import BannerSectionStyle3 from '../../components/HomePage/components/Section/BannerSection/BannerSectionStyle3'
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import AppointmentWithContactInfoSection from '../../components/HomePage/components/Section/AppointmentWithContactInfoSection';
import letstalk from '../../images/lets-talks.png'
import Section from '../../components/HomePage/components/Section';
import bgGlobe from '../../images/backgrounds/bgGlobe.webp';


const LetsTalk = () => {
  return (
    <>
    <Header/>
    <Section>
    <BannerSectionStyle3
     bgUrl={bgGlobe}
     imgUrl={letstalk}
     title="Get in touch with our team!"
     subTitle="Contact us today to explore how Kodo can help you."
    //  btnText="Get Starter"
    //  btnUrl="/contact"
     />
     </Section>
     <Section style={{ backgroundColor : '#EBE5FF' }}>
    <AppointmentWithContactInfoSection />
    </Section>
    <Footer/>
    </>
  )
}

export default LetsTalk